"use strict";
import { useSelector } from "react-redux";
import { useEnabledChains } from "features/chains/hooks/useEnabledChains";
import {
  selectIsTestnetModeEnabled,
  selectWalletHideSmallBalancesSetting,
  selectWalletHideSpamTokensSetting
} from "features/settings/selectors";
import { isMobileApp } from "utilities/src/platform";
export function useHideSmallBalancesSetting() {
  const { isTestnetModeEnabled } = useEnabledChains();
  return useSelector(selectWalletHideSmallBalancesSetting) && !isTestnetModeEnabled;
}
export function useHideSpamTokensSetting() {
  return useSelector(selectWalletHideSpamTokensSetting);
}
export const TESTNET_MODE_BANNER_HEIGHT = 44;
function useIsTestnetModeEnabled() {
  return useSelector(selectIsTestnetModeEnabled);
}
export function useTestnetModeBannerHeight() {
  const isTestnetModeEnabled = useIsTestnetModeEnabled();
  return isTestnetModeEnabled && isMobileApp ? TESTNET_MODE_BANNER_HEIGHT : 0;
}
